import { render, staticRenderFns } from "./PropertyUnits.vue?vue&type=template&id=142089b6"
import script from "./PropertyUnits.vue?vue&type=script&lang=js"
export * from "./PropertyUnits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports